import React from "react";
import { FacilityOrderPatientNewFlowUSIntakePreviewTemplate } from "themes/application/facility-order-new-flow-us-intake/components";
import { FacilityOrderPatientNewFlowUSIntakePreviewViewStore } from 'application/facility-order-new-flow-us-intake/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityOrderPatientNewFlowUSIntakePreviewViewStore(rootStore, componentProps), 'facilityOrderPatientNewFlowUSIntakePreviewViewStore')
@observer
class FacilityOrderPatientNewFlowUSIntakePreview extends React.Component {
	render() {
		return <FacilityOrderPatientNewFlowUSIntakePreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderPatientNewFlowUSIntakePreview;